import { render, staticRenderFns } from "./JSTester.vue?vue&type=template&id=3b4a35f0&scoped=true&"
import script from "./JSTester.vue?vue&type=script&lang=js&"
export * from "./JSTester.vue?vue&type=script&lang=js&"
import style0 from "./JSTester.vue?vue&type=style&index=0&id=3b4a35f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a35f0",
  null
  
)

export default component.exports